import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        activeSectionId: undefined,
        activeSectionName: undefined,
        isEpBarVisible: false,
        isEpOverlayOpen: false,
        isBrandbarExpanded: true,
        logoColorScheme: 'default',
        backgroundShape: 'opener',
        hasTouchSupport: false,
        activeVideoId: undefined,
        isVideoModalOpen: false,
        isArModalOpen: false,
        isCookieConfiguratorModalOpen: false,
        cookieSettings: { necessary: true, vimeo: false, showBar: true },
    },
    actions: {
        goToSection({ commit }, payload) {
            commit('setEpOverlayVisibility', false);
            commit('setActiveSectionId', payload.id);
            commit('setActiveSectionName', payload.name);

            if (payload.backgroundShape) {
                commit('setBackgroundShape', payload.backgroundShape);
            }
            
            if (payload.name.startsWith('ep-') || payload.name === 'experience-principles') {
                commit('setEpNavBarVisibility', true);
            } else {
                commit('setEpNavBarVisibility', false);
            }

            if (payload.name !== 'opener') {
                commit('collapseBrandbar');
            }

            if (payload.logoColorScheme) {
                commit('setLogoColorScheme', payload.logoColorScheme);
            } else {
                commit('setLogoColorScheme', 'default');
            }
        },
        updateLogoColorScheme({ commit }, payload) {
            commit('setLogoColorScheme', payload);
        },
        toggleEpOverlay({ commit }) {
            commit('setEpOverlayVisibility', !this.state.isEpOverlayOpen);
        },
        toggleVideoModal({ commit }) {
            commit('setVideoModalVisibility', !this.state.isVideoModalOpen);
        },
        toggleArModal({ commit }) {
            commit('setArModalVisibility', !this.state.isArModalOpen);
        },
        updateActiveVideoId({ commit }, payload) {
            commit('setActiveVideoId', payload);
        },
        updateBackgroundShape({ commit }, payload) {
            commit('setBackgroundShape', payload);
        },
        updateTouchSupport({ commit }, payload) {
            commit('setTouchSupport', payload);
        },
        collapseBrandbar({ commit }) {
            commit('collapseBrandbar');
        },
        updateCookieSettings({ commit }, payload) {
            commit('setCookieSettings', payload);
        },
        toggleCookieConfiguratorModal({ commit }) {
            commit('setCookieConfiguratorModalVisibility', !this.state.isCookieConfiguratorModalOpen);
        },
    },
    mutations: {
        setActiveSectionId(state, payload) {
            state.activeSectionId = payload;
        },
        setActiveSectionName(state, payload) {
            state.activeSectionName = payload;
        },
        setEpNavBarVisibility(state, payload) {
            state.isEpBarVisible = payload;
        },
        setLogoColorScheme(state, payload) {
            state.logoColorScheme = payload;
        },
        setEpOverlayVisibility(state, payload) {
            state.isEpOverlayOpen = payload;
        },
        setVideoModalVisibility(state, payload) {
            state.isVideoModalOpen = payload;
        },
        setArModalVisibility(state, payload) {
            state.isArModalOpen = payload;
        },
        setActiveVideoId(state, payload) {
            state.activeVideoId = payload;
        },
        setBackgroundShape(state, payload) {
            state.backgroundShape = payload;
        },
        setTouchSupport(state, payload) {
            state.hasTouchSupport = payload;
        },
        collapseBrandbar(state) {
            state.isBrandbarExpanded = false;
        },
        setCookieSettings(state, payload) {
            state.cookieSettings = payload;
        },
        setCookieConfiguratorModalVisibility(state, payload) {
            state.isCookieConfiguratorModalOpen = payload;
        },
    },
    getters: {
        showEpNavBar: state => state.isEpBarVisible,
        activeSectionName: state => state.activeSectionName,
        activeSectionId: state => state.activeSectionId,
        logoColorScheme: state => state.logoColorScheme,
        isEpOverlayOpen: state => state.isEpOverlayOpen,
        isVideoModalOpen: state => state.isVideoModalOpen,
        isArModalOpen: state => state.isArModalOpen,
        backgroundShape: state => state.backgroundShape,
        hasTouchSupport: state => state.hasTouchSupport,
        isBrandbarExpanded: state => state.isBrandbarExpanded,
        activeVideoId: state => state.activeVideoId,
        cookieSettings: state => state.cookieSettings,
        isCookieConfiguratorModalOpen: state => state.isCookieConfiguratorModalOpen,
    },
    modules: {},
});

export default store;
